module.exports = __webpack_public_path__ + "media/images/element/lego-a12a09f68a9cb6c5ff2eb0e885c0f72c.svg";